export const START_BENCH_FLOW = 'POKEMON/START_BENCH_FLOW';
export const START_BENCH = 'POKEMON/START_BENCH';
export const BENCH = 'POKEMON/BENCH';
export const BENCH_CANCEL = 'POKEMON/BENCH_CANCEL';
export const END_BENCH = 'POKEMON/END_BENCH';

export const START_ATTACH_FLOW = 'POKEMON/START_ATTACH_FLOW';
export const START_ATTACH = 'POKEMON/START_ATTACH';
export const ATTACH = 'POKEMON/ATTACH';
export const ATTACH_CANCEL = 'POKEMON/ATTACH_CANCEL';
export const END_ATTACH = 'POKEMON/END_ATTACH';

export const PUT_ACTIVE_POKEMON = 'POKEMON/PUT_ACTIVE_POKEMON';
export const END_PUT_BENCH_AS_ACTIVE_POKEMON = 'POKEMON/END_PUT_BENCH_AS_ACTIVE_POKEMON';
/** Whirlwind hit your active Pokémon: you pick the benched Pokémon that switches in. */
export const SWITCH_IN = 'POKEMON/SWITCH_IN';
export const END_SWITCH_IN = 'POKEMON/END_SWITCH_IN';

export const SET_ACTIVE_BENCH = 'POKEMON/SET_ACTIVE_BENCH';
export const UNSET_ACTIVE_BENCH = 'POKEMON/UNSET_ACTIVE_BENCH';

export const START_EVOLVE_FLOW = 'POKEMON/START_EVOLVE_FLOW';
export const START_EVOLVE = 'POKEMON/START_EVOLVE';
export const EVOLVE = 'POKEMON/EVOLVE';
export const EVOLVE_CANCEL = 'POKEMON/EVOLVE_CANCEL';
export const END_EVOLVE = 'POKEMON/END_EVOLVE';
